import React from "react";

export const HomePage: React.FunctionComponent = () => {
    return <div>Hello at homepage</div>;
};
